import React from 'react';
import SEO from "../components/SEO/SEO";
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import { useSigilContext } from '../context/sigilContext';

const FAQ = () => {
    const { i18n } = useSigilContext();
    const faq = i18n.faq;

    if (!faq) return null;

    return (
        <Container maxWidth="md" sx={{ py: 6 }}>
            <SEO 
                title={`${faq.title} | Magia del Caos`}
                description="Respuestas a las preguntas más comunes sobre la creación de sigilos y la magia del caos moderna."
                name="Magia del Caos"
                type="article"
            />
            
            <Typography variant="h3" component="h1" gutterBottom sx={{ 
                color: 'primary.main', 
                fontWeight: 'bold',
                textAlign: 'center',
                mb: 4
            }}>
                {faq.title}
            </Typography>

            <Box sx={{ mt: 4 }}>
                {faq.items.map((item, index) => (
                    <Accordion key={index} sx={{ 
                        backgroundColor: 'rgba(255, 255, 255, 0.05)', 
                        color: 'white',
                        mb: 1,
                        '&:before': { display: 'none' }
                    }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: 'primary.main' }} />}
                            aria-controls={`panel${index}-content`}
                            id={`panel${index}-header`}
                        >
                            <Typography sx={{ fontWeight: '500' }}>{item.question}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                                {item.answer}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Box>
        </Container>
    );
};

export default FAQ;
